import { useRef } from 'react';

export default function OtpInput({ value, onChange }) {
  const inputs = useRef([]);
  const digits = Array.from({ length: 5 }, (_, index) => value[index] || '');

  const updateAt = (index, inputValue) => {
    const entered = inputValue.replace(/\D/g, '').slice(0, 5);
    if (entered.length > 1) {
      onChange(entered);
      inputs.current[Math.min(entered.length, 4)]?.focus();
      return;
    }

    const digit = entered.slice(-1);
    const next = [...digits];
    next[index] = digit;
    onChange(next.join(''));
    if (digit && index < 4) inputs.current[index + 1]?.focus();
  };

  return (
    <div className="otp-input-group" role="group" aria-label="کد تأیید پنج‌رقمی">
      {digits.map((digit, index) => (
        <input
          key={`otp-digit-${index}`}
          ref={(element) => { inputs.current[index] = element; }}
          type="text"
          inputMode="numeric"
          autoComplete={index === 0 ? 'one-time-code' : 'off'}
          maxLength={1}
          value={digit}
          aria-label={`رقم ${index + 1}`}
          onChange={(event) => updateAt(index, event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Backspace' && !digit && index > 0) {
              inputs.current[index - 1]?.focus();
            }
          }}
          onPaste={(event) => {
            const pasted = event.clipboardData.getData('text').replace(/\D/g, '').slice(0, 5);
            if (!pasted) return;
            event.preventDefault();
            onChange(pasted);
            inputs.current[Math.min(pasted.length, 4)]?.focus();
          }}
        />
      ))}
    </div>
  );
}
